import { EmptyState as ChakraEmptyState, VStack } from '@chakra-ui/react';
import { forwardRef } from 'react';

import Icon, { IconType } from './Icon';

type EmptyStateProps = ChakraEmptyState.RootProps & {
  title: string;
  description?: string;
  icon?: IconType;
};

const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ title, description, icon, children, ...rest }, ref) => (
    <ChakraEmptyState.Root
      ref={ref}
      display="flex"
      justifyContent="center"
      {...rest}
    >
      <ChakraEmptyState.Content>
        {icon && (
          <ChakraEmptyState.Indicator>
            <Icon color="gray.600" fontSize="7xl" icon={icon} />
          </ChakraEmptyState.Indicator>
        )}
        {description ? (
          <VStack textAlign="center">
            <ChakraEmptyState.Title
              color="gray.600"
              fontSize="2xl"
              fontWeight="normal"
            >
              {title}
            </ChakraEmptyState.Title>
            <ChakraEmptyState.Description color="gray.500" fontSize="md">
              {description}
            </ChakraEmptyState.Description>
          </VStack>
        ) : (
          <ChakraEmptyState.Title
            color="gray.600"
            fontSize="xl"
            fontWeight="normal"
          >
            {title}
          </ChakraEmptyState.Title>
        )}
        {children}
      </ChakraEmptyState.Content>
    </ChakraEmptyState.Root>
  )
);

export default EmptyState;
